import { useEffect, useMemo, useRef } from "react"

import {
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip
} from "chart.js"
import { Line } from "react-chartjs-2"
import { useSelector } from "react-redux"

import { debounce } from "../../../Utils/utils"
import { getGradient, tooltipLine } from "../../DashboardPage/components/chartsPlagins"
import { totalUsersChartOptions } from "./chartsOptions"

ChartJS.register(TimeScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

ChartJS.defaults.color = "#667085"
// ChartJS.defaults.font.family = 'FontAwesome, Inter, sans-serif';

ChartJS.defaults.font.family = "Inter, sans-serif"
ChartJS.defaults.plugins.tooltip.titleAlign = "center"
ChartJS.defaults.plugins.tooltip.padding = 12
ChartJS.defaults.plugins.tooltip.titleMarginBottom = 8
ChartJS.defaults.plugins.tooltip.titleFont = {
  fontFamily: "Inter, sans-serif",
  lineHeight: 1.2,
  size: 14,
  style: "normal",
  weight: "700"
}

const TotalUsersChart = ({ totalUsersData }) => {
  // const { alertsOverviewData, alertsOverviewFetching, filters} = useSelector(state => state.dashboard)
  const theme = useSelector((state) => state.nav.theme)
  //for better resize chart if resize window
  const chartRef = useRef(null)

  const handleResize = debounce(() => {
    if (chartRef.current) {
      chartRef.current.resize()
    }
  }, 500)

  //for udate chart after changing browser tab if chart is unvisible
  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible" && chartRef.current) {
      chartRef.current.update()
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () => {
      window.removeEventListener("resize", handleResize)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  const chartOptions = useMemo(() => totalUsersChartOptions(theme), [theme])

  const getChartData = (data) => ({
    labels: data?.labels,
    datasets: [
      {
        label: "All projects",
        data: data?.result?.data,

        total: data?.result?.data,

        borderColor: "#225AEA",
        borderWidth: 2,
        pointHoverRadius: 8,
        pointHoverBorderWidth: 2,
        pointHoverBackgroundColor: "white",
        yAxisID: "y",
        fill: true,
        backgroundColor: function (context) {
          const chart = context.chart
          const { ctx, chartArea } = chart
          if (!chartArea) return
          return getGradient(ctx, chartArea)
        }
      }
    ]
  })

  const chartData = getChartData(totalUsersData)

  return (
    <Line
      ref={chartRef}
      options={chartOptions}
      data={chartData}
      height={260}
      plugins={[tooltipLine]}
    />
  )
}

export default TotalUsersChart
